import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable, Type } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private readonly overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;

  public attach<T>(component: Type<T>): void {
    if (this.overlayRef?.hasAttached()) {
      return;
    }

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create();
    }
    const componentPortal = new ComponentPortal(component);
    this.overlayRef?.attach(componentPortal);
  }

  public detach(): void {
    this.overlayRef?.detach();
  }
}
